// Domain interfaces

export type BrokerSettings = MyBrokerApi.BrokerSettings;

export type HSL = {
    hue: number;
    saturation: number;
    lightness: number;
};

export type Palette = {
    primary: HSL;
    secondary: HSL;
    tertiary: HSL;
};

export type BrokerColors = {
    default: Palette;
    foreground: Palette;
};

export const brokerColorsDefault = (): BrokerColors => ({
    default: {
        primary: { hue: 225, saturation: 53, lightness: 30 },
        secondary: { hue: 198, saturation: 100, lightness: 44 },
        tertiary: { hue: 51, saturation: 100, lightness: 49 },
    },
    foreground: {
        primary: { hue: 0, saturation: 0, lightness: 100 },
        secondary: { hue: 0, saturation: 0, lightness: 100 },
        tertiary: { hue: 225, saturation: 53, lightness: 30 },
    },
});
